const data = [
    { id: 1, name: "Termos de uso" },
    { id: 2, name: "Política de privacidade" },
    
  ];
  
  export default [...data];